import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { HomePage } from "./pages/HomePage";
import { AdvertisingPage } from "./pages/AdvertisingPage";
import { ContactPage } from "./pages/ContactPage";
import { AdminPage } from "./pages/AdminPage";
import { QuizPage } from "./pages/QuizPage";
import { LoginPage } from "./pages/LoginPage";
import { TrailMapsPage } from "./pages/TrailMapsPage";
import { HousingMarketPage } from "./pages/HousingMarketPage";
import { CommunityGuidePage } from "./pages/CommunityGuidePage";
import { BusinessResourcesPage } from "./pages/BusinessResourcesPage";
import { BlogDetailPage } from "./pages/BlogDetailPage";
import { CostCalculatorPage } from "./pages/CostCalculatorPage";
import { ExplorePage } from "./pages/ExplorePage";
import { SalaryComparisonPage } from "./pages/SalaryComparisonPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/advertising" element={<AdvertisingPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/quizzes" element={<QuizPage />} />
            <Route path="/trail-maps" element={<TrailMapsPage />} />
            <Route path="/housing-market" element={<HousingMarketPage />} />
            <Route path="/community-guide" element={<CommunityGuidePage />} />
            <Route path="/business-resources" element={<BusinessResourcesPage />} />
            <Route path="/blog/:id" element={<BlogDetailPage />} />
            <Route path="/cost-calculator" element={<CostCalculatorPage />} />
            <Route path="/explore" element={<ExplorePage />} />
            <Route path="/salary-comparison" element={<SalaryComparisonPage />} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
      </div>
    </BrowserRouter>
  );
}

export default App;
